import React, { Component } from "react";
import { Link } from "react-router-dom";

class MenuRelatorio extends Component {
  render() {
    return (
      <li className="nav-item">
        <Link to="/relatorio/producao" className="nav-link">
          <i className="link-icon icon-printer" />
          <span className="menu-title">Relatório</span>
          <i className="menu-arrow" />
        </Link>
        <div className="submenu">
          <ul className="submenu-item">
            <li className="nav-item">
              <Link className="nav-link" to="/relatorio/apuracao">
                Apuração por Período
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/relatorio/producao">
                Produção por Período
              </Link>
            </li>
          </ul>
        </div>
      </li>
    );
  }
}

export default MenuRelatorio;
